const initialState = {
    setting: {},
    loading: false,
    error: ''
  }
  
  const settingReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SETTING_REQUEST':
        return {
          ...state,
          loading: true
        }
      case 'SETTING_SUCCESS':
        return {
          ...state,
          loading: false,
          setting: action.payload,
          error: ''
        }
      case 'SETTING_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }
  
  export default settingReducer
  